{
    "PromptDeletereport": "Vous êtes sûr de vouloir supprimer ?",
    "PromptDeletereports": "Êtes-vous sûr de vouloir supprimer définitivement les rapports sélectionnés ?",
    "PromptEmptyrecyclebin": "Êtes-vous sûr de vouloir supprimer définitivement tous les rapports dans la corbeille ?",
    "PromptRemovereport": "Vous êtes sûr de vouloir supprimer ce rapport ?",
    "PromptReportswillbedeletedpermanently": "Les rapports seront définitivement supprimés et ne pourront pas être restaurés.",
    "AreYouSureDelete": "Vous êtes sûr de vouloir supprimer ?",
    "AreYouSureRemove": "Vous êtes sûr de vouloir supprimer ce rapport ?",
    "LanguagePrompt_PromptConfirm": "Confirmer",
    "LanguagePrompt_PromptCancel": "Annuler",
    "NAME": "LanguagePrompt"
}